import { render, staticRenderFns } from "./BoughtHistory.vue?vue&type=template&id=392b8a38&"
import script from "./BoughtHistory.vue?vue&type=script&lang=js&"
export * from "./BoughtHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports